"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Faq = _interopRequireDefault(require("../Faq"));
var _HappyFox = _interopRequireDefault(require("../HappyFox"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var HelpCenter = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(HelpCenter, _React$Component);
  function HelpCenter(props) {
    var _this;
    _classCallCheck(this, HelpCenter);
    _this = _callSuper(this, HelpCenter, [props]);
    _defineProperty(_assertThisInitialized(_this), "state", {
      toggled: false
    });
    _defineProperty(_assertThisInitialized(_this), "toggleContact", function () {
      _this.setState({
        toggled: !_this.state.toggled
      });
    });
    _defineProperty(_assertThisInitialized(_this), "initializeHappyFox", function () {
      var settings = window.cccisd.appDefs.helpCenters.list.find(function (item) {
        return item.id === _this.props.helpCenter;
      });
      if (window.HFCHAT_CONFIG) {
        return;
      }
      if (!settings.liveChat.embedToken) {
        return;
      }
      window.HFCHAT_CONFIG = {
        EMBED_TOKEN: settings.liveChat.embedToken,
        ASSETS_URL: 'https://widget.happyfoxchat.com/v2/visitor'
      };
      var script = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('async', true);
      script.src = window.HFCHAT_CONFIG.ASSETS_URL + '/js/widget-loader.js';
      document.getElementsByTagName('head')[0].appendChild(script);
      window.HFCHAT_CONFIG.options = {
        showBadgeOnLoad: false,
        // Will hide badge only on load
        showBadge: false // always hide badge
      };
      window.HFCHAT_CONFIG.onload = function () {
        window.cccisd.HappyFoxChat = this;
        window.cccisd.HappyFoxChat.on('collapse:chatbox', function () {
          window.cccisd.HappyFoxChat.hideWidget();
        });
      };
    });
    _this.toggleContact = _this.toggleContact.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(HelpCenter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeHappyFox();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var settings = window.cccisd.appDefs.helpCenters.list.find(function (item) {
        return item.id === _this2.props.helpCenter;
      });
      if (typeof settings === 'undefined') {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, /*#__PURE__*/_react["default"].createElement("i", null, "Error: help center \"", this.props.helpCenter, "\" not found")));
      }
      var toggled = this.state.toggled;
      var contact = settings.contact;
      var startsOpen = false;
      var showContactText = 'I still need help...';
      if (typeof contact.startsOpen !== 'undefined') {
        startsOpen = contact.startsOpen;
      }
      if (typeof contact.showContactText !== 'undefined') {
        showContactText = contact.showContactText;
      }
      var faq = '';
      var contactBlock = '';
      var contactInfo = '';
      var chat = '';
      if (settings.showFaq) {
        faq = /*#__PURE__*/_react["default"].createElement(_Faq["default"], settings.faq);
      }
      if (settings.showChat) {
        chat = /*#__PURE__*/_react["default"].createElement(_HappyFox["default"], settings.liveChat);
      }
      if (contact.email || contact.phone) {
        contactInfo = /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].contact
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: contact.contactHeader
        }), /*#__PURE__*/_react["default"].createElement("ul", null, contact.email && /*#__PURE__*/_react["default"].createElement("li", null, "Email: ", /*#__PURE__*/_react["default"].createElement("a", {
          href: 'mailto:' + contact.email
        }, contact.email)), contact.phone && /*#__PURE__*/_react["default"].createElement("li", null, "Phone: ", contact.phone)));
      }
      if (chat || contactInfo) {
        if (startsOpen || toggled) {
          contactBlock = /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].contactWrapper
          }, contactInfo, chat);
        } else {
          contactBlock = /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].contactWrapper
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].contactToggle
          }, /*#__PURE__*/_react["default"].createElement("a", {
            onClick: this.toggleContact
          }, showContactText)));
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: _style["default"].helpCenter
      }, faq, faq && contactBlock && /*#__PURE__*/_react["default"].createElement("hr", null), contactBlock);
    }
  }]);
  return HelpCenter;
}(_react["default"].Component);
_defineProperty(HelpCenter, "propTypes", {
  helpCenter: _propTypes["default"].string
});
_defineProperty(HelpCenter, "defaultProps", {
  helpCenter: 'default'
});